(() => {
  if (customElements.get('diggn-visual-nav')) return;
  class DiggnVisualNav extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-dgv-filter]')];
      this.products = [...this.querySelectorAll('[data-dgv-product]')];
      this.count = this.querySelector('[data-dgv-count]');
      this.onFilter = event => {
        const button = event.target.closest('[data-dgv-filter]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        // Native HeaderDrawer binds every button as a Back action. Intercept filters first.
        event.stopPropagation();
        this.filter(button.dataset.dgvFilter);
        const submenu = this.closest('.menu-drawer__submenu');
        if (submenu && typeof trapFocus === 'function') trapFocus(submenu, button);
      };
      this.addEventListener('click', this.onFilter, true);
      this.filter('all');
    }
    disconnectedCallback() { this.removeEventListener('click', this.onFilter, true); }
    filter(group) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dgvFilter === group)));
      let count = 0;
      this.products.forEach(product => {
        product.hidden = group !== 'all' && product.dataset.dgvGroup !== group;
        product.querySelectorAll('a,button,[tabindex]').forEach(link => {
          if (product.hidden) link.setAttribute('tabindex', '-1');
          else link.removeAttribute('tabindex');
        });
        if (!product.hidden) count++;
      });
      if (this.count) this.count.textContent = String(count);
    }
  }
  customElements.define('diggn-visual-nav', DiggnVisualNav);

  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('details.dgv-desktop-details[open]').forEach(details => {
      if (details.contains(event.target)) return;
      details.open = false;
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
  });

  const drawer = document.getElementById?.('Details-menu-drawer-container');
  const header = document.querySelector?.('.section-header');
  if (drawer && header) {
    let frame;
    const measure = () => {
      frame = null;
      if (!drawer.open) return;
      document.documentElement.style.setProperty('--header-bottom-position', `${Math.max(0, Math.floor(header.getBoundingClientRect().bottom - 1))}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
    drawer.addEventListener('toggle', schedule);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(schedule).observe(header);
  }
})();
